"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ReplyBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _conversation = require('shared/selectors/conversation');
var _replyPreview = require('shared/services/replyPreview');
var _ReplyPreviewStrip = require('./ReplyPreviewStrip'); var _ReplyPreviewStrip2 = _interopRequireDefault(_ReplyPreviewStrip);
var _hooks = require('web/services/hooks');









const ReplyBar = ({
  preview, onCancel, onJump, conversationKey, messageKey,
}) => {
  const targetFacts = _hooks.useAppSelector.call(void 0, state =>
    _conversation.selectReplyTargetFacts.call(void 0, state, conversationKey, messageKey),
  )
  const resolved = _replyPreview.resolveReplyPreview.call(void 0, preview, targetFacts)

  if (!resolved) return null

  return (
    _react2.default.createElement('div', { className: "reply-bar", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      , _react2.default.createElement('button', {
        type: "button",
        className: "reply-bar--label",
        'aria-label': `Jump to message from ${resolved.displayName}`,
        onClick: onJump, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

        , _react2.default.createElement(_ReplyPreviewStrip2.default, { preview: resolved, variant: "composer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
      )
      , _react2.default.createElement('button', {
        type: "button",
        className: "reply-bar--cancel",
        'aria-label': "Cancel reply" ,
        onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
, "✕"

      )
    )
  )
}

exports. default = ReplyBar
